export const PALETTE = ['#2f6fb3', '#d97a2b', '#3c9a5f', '#b2445a', '#7a5bb0', '#2a9aa6', '#a68a2b', '#5c6f80', '#c55a9a', '#6b8e23'];
/**
 * 선택 범위 → 차트 (순수). cells[행][열] 은 원래 값, texts 는 화면 글자.
 * 첫 컬럼이 숫자가 아니면 그 컬럼이 이름(라벨), 아니면 rowLabels(행 머리 — 그리드의 첫 글자 컬럼) 또는 "1행, 2행…".
 * 숫자가 하나도 없는 컬럼은 계열에서 뺀다.
 */
export function chartFromRange(headers, cells, texts, o = {}) {
    const num = (v) => (typeof v === 'number' ? v : v == null || v === '' ? null : Number.isFinite(Number(v)) ? Number(v) : NaN);
    const n = Math.min(cells.length, o.limit ?? 200);
    const isNumCol = (c) => { let any = false; for (let r = 0; r < n; r++) {
        const x = num(cells[r][c]);
        if (x == null)
            continue;
        if (x !== x)
            return false;
        any = true;
    } return any; };
    const firstLabel = headers.length > 1 && !isNumCol(0);
    const labels = Array.from({ length: n }, (_, r) => firstLabel ? texts[r][0] : o.rowLabels?.[r] ?? `${r + 1}행`);
    const series = [];
    for (let c = firstLabel ? 1 : 0; c < headers.length; c++) {
        if (!isNumCol(c))
            continue;
        series.push({ name: headers[c], values: Array.from({ length: n }, (_, r) => { const x = num(cells[r][c]); return x == null || x !== x ? null : x; }) });
    }
    return { type: o.type ?? 'bar', title: o.title, labels, series };
}
/** 셀·툴팁용 미니 추이선 */
export function sparklineSvg(values, w = 80, h = 20, color = '#2f6fb3') {
    const v = values.filter((x) => x != null);
    if (v.length < 2)
        return '';
    const lo = Math.min(...v), hi = Math.max(...v), n = values.length;
    const pts = values.map((x, i) => (x == null ? null : `${(i / (n - 1)) * (w - 4) + 2},${h - 2 - ((x - lo) / (hi - lo || 1)) * (h - 4)}`)).filter(Boolean);
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}"><polyline points="${pts.join(' ')}" fill="none" stroke="${color}" stroke-width="1.5"/></svg>`;
}
